/**
 * tab store
 * { title: '', path: '' }
 */

const defaultTitle = '.....';
// import { pointTools , traceClick} from '@/utils/point';
import { uuid4 , getObjectIdFromUrl, getApiKeyFromURL, getPathFromRouteCache, getMenuCode} from '@/utils/utils';
const tabs = {
  state: {
    list: [],
    curTab: '',
    flushingList: [],
  },
  mutations: {
    addTab(state, tab) {
      if (tab.path) {
        const hasPage = state.list.some((pane) => (pane.path === tab.path));
        if (!hasPage) {
          if (!tab.title) {
            // eslint-disable-next-line no-param-reassign
            tab.title = defaultTitle;
          }
          state.list.push(tab);
        }
      }
    },
    fixTab(state, data) {
      function getTabTitle(path) {
        let title = '';
        /**
         * 遍历菜单 href === url 赋值title (如果菜单名字后端返回，采用后端返回，不是，采用路由名称)
         */
        let menuList;
        // eslint-disable-next-line no-unused-expressions
        localStorage.getItem('menuList') ? menuList = JSON.parse(localStorage.getItem('menuList')) : menuList = [];
        menuList.forEach((em) => {
          if (em.children) {
            em.children.forEach((cm) => {
              if (path === cm.menuUrl) {
                title = cm.name;
              }
            });
          }
        });
        return title;
      }
      Object.values(data).forEach((route) => {
        const { href, meta: { title = '' } = {}, query} = route;
        if (title) {
          state.list.forEach((pane) => {
            if (href === pane.path) {
              pane.title = getTabTitle(href) ? getTabTitle(href) : title;
              try {
                if(query && query.currentTabName) {
                  pane.title = query.currentTabName;
                }
              } catch (error) {

              }
              // eslint-disable-next-line no-param-reassign
            }
          });
        }
      });
      // 统计页面留存耗时
      // 拿到最后一个tab页
      const tab = state.list.find(item => item.path === `${window.location.pathname}${window.location.search || ""}`);
      // const tab = state.list[state.list.length - 1];
      if (tab) {
        const has = state.flushingList.findIndex((item) => item.path === tab.path);
        // 去重
        if (has > -1) {
          state.flushingList.splice(has, 1);
        }
        // 跳转后，补全前面的tab页结束时间
        state.flushingList.filter((item) => !item.endTime).forEach((item) => {
          if (!item.endTime) {
            // eslint-disable-next-line no-param-reassign
            item.endTime = new Date().toLocaleString();
          }
        });
        // 添加新页签
        state.flushingList.push({
          ...tab,
          startTime: new Date().toLocaleString(),
          endTime: null,
          page_sid: uuid4(),
          object_id: getObjectIdFromUrl(),
          page_code: getApiKeyFromURL(),
          menu_code: getMenuCode(),
          referer: getPathFromRouteCache(),
        });
        function getParams(index) {
          return {
            page_sid: state.flushingList[state.flushingList.length - index].page_sid || '',
            menu_name: state.flushingList[state.flushingList.length - index].title,
            url: state.flushingList[state.flushingList.length - index].path,
            object_id: state.flushingList[state.flushingList.length - index].object_id,
            page_code: state.flushingList[state.flushingList.length - index].page_code,
            menu_code: state.flushingList[state.flushingList.length - index].menu_code,
            referer: state.flushingList[state.flushingList.length - index].referer,
          }
        }
        if(state.flushingList.length > 1) {
          // traceClick({
          //   event_type: 'page_view',
          //   content: {
          //     action: 'end',
          //    ...getParams(2)
          //   }
          // })
          // traceClick({
          //   event_type: 'page_view',
          //   content: {
          //     action: 'start',
          //     ...getParams(1)
          //   }
          // })
        }else {
          // traceClick({
          //   event_type: 'page_view',
          //   content: {
          //     action: 'start',
          //     ...getParams(1)
          //   }
          // })
        }
      }
    },
    delTab(state, index) {
      const pane = state.list.splice(index, 1);
      const flushPane = state.flushingList.find((item) => item.path === pane[0].path);
      // 只记录当前tab页结束时间；其余tab在隐藏时已经记录
      if (!flushPane || window.location.href.indexOf(flushPane.path) === -1) return;
      flushPane.endTime = new Date().toLocaleString();
    },
    delCurTab(state, fullPath) {
      const index = state.list.findIndex((pane) => (pane.path === fullPath));
      if (index >= 0) {
        const pane = state.list.splice(index, 1);
        const flushPane = state.flushingList.find((item) => item.path === pane[0].path);
        if (!flushPane || window.location.href.indexOf(flushPane.path) === -1) return;
        flushPane.endTime = new Date().toLocaleString();
      }
    },
    emptyTab(state) {
      state.list = [];
    },
    emptyFlushingTab(state) {
      state.flushingList = [];
    },
    delAllTab(state, fullPath) {
      const index = state.list.findIndex((pane) => (pane.path === fullPath));
      function keepAtIndex(a, k) {
        const result = a.filter((_, i) => i === k);
        return result;
      }
      state.list = keepAtIndex(state.list, index);
    },
  },
};

export default tabs;
